/*
*
* File JS per il template Archive Magazine
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroPage from 'components/hero-page/hero-page';
import cardStore from 'components/cards/card-store/card-store';
import blockNews from 'components/block-news/block-news';



// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-flyers.scss';



// LOGICA COMPONENTE
//--------------------------------------------------------------------//

const flyerFilters = () =>
{
    const selectCity = document.querySelector('.archive-flyer__search select');
    const resultsContainer = document.querySelector('.archive-flyer__results-stores');
    const results = resultsContainer.querySelectorAll('.card-store');
    const message = document.querySelector('.archive-flyer__results-message');

    let visibleFlyer = results.length;

    const checkEmpty = () =>
    {
        if( visibleFlyer == 0 )
        {
            resultsContainer.classList.add('is-hidden');
            message.classList.remove('is-hidden');
        }
        else
        {
            resultsContainer.classList.remove('is-hidden');
            message.classList.add('is-hidden');
        }
    }

    const showAllResult = () =>
    {
        results.forEach(result =>
        {
            result.classList.remove('is-hidden');
        });

        visibleFlyer = results.length;
        checkEmpty();
    }

    const showOnlyFilter = () =>
    {
        visibleFlyer = 0;

        results.forEach(result =>
        {
            if( result.dataset.city == selectCity.value )
            {
                result.classList.remove('is-hidden');
                visibleFlyer ++;
            }
            else
            {
                result.classList.add('is-hidden');
            }
        });

        checkEmpty();
    }

    selectCity.onchange = (evt) =>
    {
        if( selectCity.value < 0 )
        {
            showAllResult();
        }
        else
        {
            showOnlyFilter();
        }
    }
        
    checkEmpty();
}


// INIT COMPONENTI
//--------------------------------------------------------------------//

flyerFilters();

//--------------------------------------------------------------------//